import { render } from "./MessageFeed.vue?vue&type=template&id=114f1d64&ts=true"
import script from "./MessageFeed.vue?vue&type=script&lang=ts"
export * from "./MessageFeed.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__